import { Div, RefNumber, TableBuilder, Select, TextInput, NumberInput, Text, Line } from "@tblabs/truffle";
import { Expanse } from "../../Models/Expanse";
import { FatalError } from "../../Components/FatalError";
import { DateTimeSlider } from "../../Components/Utils/DateTimeSlider";
import { Icons } from "../../Components/Utils/Icons";
import { XDangerButton } from "../../Components/Utils/XDangerButton";
import { XPrimaryButton } from "../../Components/Utils/XPrimaryButton";
import { ExpansesRepo } from "../../Services/ExpansesRepo";
import { AgentsProvider } from "../../Services/AgentsProvider";
import { AuthService } from "../../Services/Auth/AuthService";
import { Router } from "../../Services/Router";


export class ExpensesPage extends Div
{
    constructor(private _router: Router, private _auth: AuthService, private _agents: AgentsProvider, private _expansesRepo: ExpansesRepo)
    {
        super();

        if (!_auth.IsAuthorized || !_auth.UserInfo?.Permissions?.CanSeeExpanses)
        {
            this.Append(new FatalError("Nie masz uprawnień do oglądania tej strony"));
            return;
        }
    }

    async OnAppend()
    {
        await this._expansesRepo.Download();

        const expanses = this._expansesRepo.Expanses;

        const sum = new RefNumber();
        expanses.OnChange(() => sum.value = expanses.Items.reduce((acc, x) => acc + x.Amount.value, 0), true);

        this.Append(
            new TableBuilder(expanses)
                .AddColumn("Kategoria", x => new Select(x.Category, ["Części", "Reklama", "Prowizja Agentów", "Narzędzia", "Transport", "Inne"]))
                .AddColumn("Wydatek", x => new TextInput(x.Description))
                .AddColumn("Kwota", x => new NumberInput(x.Amount))
                .AddColumn("Data", x => new DateTimeSlider(x.When))
                .AddColumn("", x => new XDangerButton("Usuń", Icons.Trash, () => expanses.Remove(x)))
                .Build(),
            "Suma: ", new Text(sum),
            new Line(),
            new XPrimaryButton("Dodaj wydatek", Icons.Plus, () => expanses.Add(new Expanse({ Description: "", Amount: 0, When: new Date() }))),
            new XPrimaryButton("Zapisz zmiany", Icons.Save, () => this._expansesRepo.Update())
        );
    }
}
